interface CheckIfExpiredReturnType {
  cuttingOffInFortnight: boolean;
  cutOffInDays: number;
}

function getRetroActiveInMilliseconds(
  retroActiveDays: number,
  oneDayInMilliseconds: number,
  effectiveDate: string,
): number {
  if (retroActiveDays === 31) {
    // 31 means that cut off happens at the end of the month
    const date = new Date(effectiveDate);
    const daysAmount = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    return daysAmount * oneDayInMilliseconds;
  }
  return retroActiveDays * oneDayInMilliseconds;
}

export function checkIfCuttingOff(effectiveDate: string, retroActiveDays: number): CheckIfExpiredReturnType {
  const receivedDate = Date.parse(effectiveDate);
  const currentDate = Date.now();

  const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
  const retroActiveInMilliseconds = getRetroActiveInMilliseconds(retroActiveDays, oneDayInMilliseconds, effectiveDate);
  const timeDiff = receivedDate + retroActiveInMilliseconds + oneDayInMilliseconds - currentDate; // in milliseconds
  const timeDiffInDays = Math.trunc(timeDiff >= 0 ? timeDiff / oneDayInMilliseconds : 0);
  const cutsOffLabelDaysAmount = 15; // amount of days until cut off when we should show label
  return {
    cuttingOffInFortnight: timeDiffInDays <= cutsOffLabelDaysAmount,
    cutOffInDays: timeDiffInDays,
  };
}
